@switch (bannerType) {
  @case (bannerTypes.NoBanner) {}
  @case (bannerTypes.LastSuccessfulRunWithNewerFailure) {
    <mode-view-page-banner status="warning">
      <div class="banner">
        <span>The latest Report run failed. You're viewing data from {{ lastSuccessfullyRunAt | timeAgo }}. </span>
        <a [href]="mostRecentReportRunLink || reportLink">View the failed run</a>
      </div>
    </mode-view-page-banner>
  }
  @case (bannerTypes.SuccessfulRunWithNewerSuccess) {
    <mode-view-page-banner status="info">
      <div class="banner">
        <capra-icon icon="icon-clock" class="icon-clock"></capra-icon>
        <span>More recent data is available. You're viewing data from {{ runCompletedAt | timeAgo }}.</span>
        <a [href]="reportLink">Use the latest data</a>
      </div>
    </mode-view-page-banner>
  }
  @case (bannerTypes.FailedRunWithNewerSuccess) {
    <mode-view-page-banner status="error">
      <div class="banner">
        <span
          >You're using data from {{ runCompletedAt | timeAgo }}, some of which failed to return. More recent data is
          available.</span
        >
        <a [href]="reportLink">Use the latest data</a> |
        <a [href]="reportRunErrorLink || reportRunDetailsLink || reportLink">See the error</a>
      </div>
    </mode-view-page-banner>
  }
  @case (bannerTypes.FailedRunWithoutNewerSuccess) {
    <mode-view-page-banner status="error">
      <div class="banner">
        <span>Some of the data in this Report failed to return.</span>
        <a [href]="reportRunErrorLink || reportRunDetailsLink || reportLink">See the error</a>
      </div>
    </mode-view-page-banner>
  }
}
